import { render, staticRenderFns } from "./approvePermission.vue?vue&type=template&id=27886ab6&scoped=true&"
import script from "./approvePermission.vue?vue&type=script&lang=js&"
export * from "./approvePermission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27886ab6",
  null
  
)

export default component.exports